module.exports = __webpack_public_path__ + "static/media/vanquis-bank.0514ac46.svg";